// NOTE all the paths MUST be relative. DO NOT START THEM WITH '/'

const BASE_ROUTE = 'etr-root'

export const ROUTE_NAMES = {
  LIST: 'etr-list',
  DETAILS: 'etr-details',
  MANUAL_BID: 'manual-bid'
}

const ROUTES = {
  [BASE_ROUTE]: {
    name: BASE_ROUTE,
    path: 'etr'
  },
  [ROUTE_NAMES.LIST]: {
    name: ROUTE_NAMES.LIST,
    path: 'list'
  },
  [ROUTE_NAMES.DETAILS]: {
    name: ROUTE_NAMES.DETAILS,
    path: ':isin'
  },
  [ROUTE_NAMES.MANUAL_BID]: {
    name: ROUTE_NAMES.MANUAL_BID,
    path: ':isin/manual-bid'
  }
}

export default [
  {
    name: ROUTES[BASE_ROUTE].name,
    path: ROUTES[BASE_ROUTE].path,
    component: {
      template: '<router-view></router-view>',
      name: 'EtrModule'
    },
    children: [
      {
        name: ROUTES[ROUTE_NAMES.LIST].name,
        path: ROUTES[ROUTE_NAMES.LIST].path,
        component: (resolve) => require(['./views/list'], resolve)
      },
      {
        name: ROUTES[ROUTE_NAMES.DETAILS].name,
        path: ROUTES[ROUTE_NAMES.DETAILS].path,
        component: (resolve) => require(['./views/details'], resolve),
        props: true
      },
      {
        name: ROUTES[ROUTE_NAMES.MANUAL_BID].name,
        path: ROUTES[ROUTE_NAMES.MANUAL_BID].path,
        component: (resolve) => require(['./views/manual-bid'], resolve),
        props: true
      }
    ]
  }
]
